import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/agentic/',
    component: ComponentCreator('/agentic/', 'a5c'),
    exact: true
  },
  {
    path: '/blog/',
    component: ComponentCreator('/blog/', 'c73'),
    exact: true
  },
  {
    path: '/blog/2026/08/02/introducing-kritzel/',
    component: ComponentCreator('/blog/2026/08/02/introducing-kritzel/', '1c6'),
    exact: true
  },
  {
    path: '/blog/2026/10/22/kritzel-is-now-open-source/',
    component: ComponentCreator('/blog/2026/10/22/kritzel-is-now-open-source/', '9f2'),
    exact: true
  },
  {
    path: '/blog/archive/',
    component: ComponentCreator('/blog/archive/', '1d9'),
    exact: true
  },
  {
    path: '/license/',
    component: ComponentCreator('/license/', 'bbd'),
    exact: true
  },
  {
    path: '/docs/angular/',
    component: ComponentCreator('/docs/angular/', '3f1'),
    routes: [
      {
        path: '/docs/angular/',
        component: ComponentCreator('/docs/angular/', '434'),
        routes: [
          {
            path: '/docs/angular/',
            component: ComponentCreator('/docs/angular/', '6c5'),
            routes: [
              {
                path: '/docs/angular/advanced/agentic-cursors/',
                component: ComponentCreator('/docs/angular/advanced/agentic-cursors/', '41f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/advanced/collaboration/',
                component: ComponentCreator('/docs/angular/advanced/collaboration/', '41c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/advanced/dynamic-objects/',
                component: ComponentCreator('/docs/angular/advanced/dynamic-objects/', '374'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/advanced/import-export/',
                component: ComponentCreator('/docs/angular/advanced/import-export/', '788'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/advanced/user-management/',
                component: ComponentCreator('/docs/angular/advanced/user-management/', '50a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/editor/',
                component: ComponentCreator('/docs/angular/api-reference/editor/', '036'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/engine/',
                component: ComponentCreator('/docs/angular/api-reference/engine/', 'e96'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/icons/',
                component: ComponentCreator('/docs/angular/api-reference/icons/', '72b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/localization-terms/',
                component: ComponentCreator('/docs/angular/api-reference/localization-terms/', '2ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/objects/',
                component: ComponentCreator('/docs/angular/api-reference/objects/', '020'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/providers/',
                component: ComponentCreator('/docs/angular/api-reference/providers/', '4a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/theming/',
                component: ComponentCreator('/docs/angular/api-reference/theming/', '63c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/api-reference/tools/',
                component: ComponentCreator('/docs/angular/api-reference/tools/', '482'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/customization/fonts/',
                component: ComponentCreator('/docs/angular/customization/fonts/', '13d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/customization/icons/',
                component: ComponentCreator('/docs/angular/customization/icons/', '5d0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/customization/locales/',
                component: ComponentCreator('/docs/angular/customization/locales/', 'b7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/customization/themes/',
                component: ComponentCreator('/docs/angular/customization/themes/', '576'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/blueprint-defect-mapper/',
                component: ComponentCreator('/docs/angular/examples/blueprint-defect-mapper/', '8c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/generative-ui/',
                component: ComponentCreator('/docs/angular/examples/generative-ui/', '3f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/image-annotation-studio/',
                component: ComponentCreator('/docs/angular/examples/image-annotation-studio/', 'ac9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/object-explorer/',
                component: ComponentCreator('/docs/angular/examples/object-explorer/', '559'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/performance-showcase/',
                component: ComponentCreator('/docs/angular/examples/performance-showcase/', '352'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/examples/slideshow-presentation/',
                component: ComponentCreator('/docs/angular/examples/slideshow-presentation/', '6ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/controls/',
                component: ComponentCreator('/docs/angular/fundamentals/controls/', 'f39'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/objects/',
                component: ComponentCreator('/docs/angular/fundamentals/objects/', '151'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/persistence/',
                component: ComponentCreator('/docs/angular/fundamentals/persistence/', '133'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/tools/',
                component: ComponentCreator('/docs/angular/fundamentals/tools/', '5ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/viewport/',
                component: ComponentCreator('/docs/angular/fundamentals/viewport/', '4e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/fundamentals/workspaces/',
                component: ComponentCreator('/docs/angular/fundamentals/workspaces/', 'b56'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/getting-started/basic-usage/',
                component: ComponentCreator('/docs/angular/getting-started/basic-usage/', 'e73'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/getting-started/quick-start/',
                component: ComponentCreator('/docs/angular/getting-started/quick-start/', '7bd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/angular/license/',
                component: ComponentCreator('/docs/angular/license/', 'a4d'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/docs/react/',
    component: ComponentCreator('/docs/react/', '32f'),
    routes: [
      {
        path: '/docs/react/',
        component: ComponentCreator('/docs/react/', 'c50'),
        routes: [
          {
            path: '/docs/react/',
            component: ComponentCreator('/docs/react/', 'cd1'),
            routes: [
              {
                path: '/docs/react/advanced/agentic-cursors/',
                component: ComponentCreator('/docs/react/advanced/agentic-cursors/', 'f84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/advanced/collaboration/',
                component: ComponentCreator('/docs/react/advanced/collaboration/', '913'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/advanced/dynamic-objects/',
                component: ComponentCreator('/docs/react/advanced/dynamic-objects/', '318'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/advanced/import-export/',
                component: ComponentCreator('/docs/react/advanced/import-export/', '0d3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/advanced/user-management/',
                component: ComponentCreator('/docs/react/advanced/user-management/', 'eac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/editor/',
                component: ComponentCreator('/docs/react/api-reference/editor/', '11e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/engine/',
                component: ComponentCreator('/docs/react/api-reference/engine/', 'deb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/icons/',
                component: ComponentCreator('/docs/react/api-reference/icons/', '63b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/localization-terms/',
                component: ComponentCreator('/docs/react/api-reference/localization-terms/', 'ccd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/objects/',
                component: ComponentCreator('/docs/react/api-reference/objects/', 'e93'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/providers/',
                component: ComponentCreator('/docs/react/api-reference/providers/', '4a4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/theme-tokens/',
                component: ComponentCreator('/docs/react/api-reference/theme-tokens/', '929'),
                exact: true
              },
              {
                path: '/docs/react/api-reference/theming/',
                component: ComponentCreator('/docs/react/api-reference/theming/', '0ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/tools/',
                component: ComponentCreator('/docs/react/api-reference/tools/', '042'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/api-reference/types/',
                component: ComponentCreator('/docs/react/api-reference/types/', 'f98'),
                exact: true
              },
              {
                path: '/docs/react/customization/fonts/',
                component: ComponentCreator('/docs/react/customization/fonts/', '194'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/customization/icons/',
                component: ComponentCreator('/docs/react/customization/icons/', '5f8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/customization/locales/',
                component: ComponentCreator('/docs/react/customization/locales/', '43a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/customization/themes/',
                component: ComponentCreator('/docs/react/customization/themes/', '214'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/blueprint-defect-mapper/',
                component: ComponentCreator('/docs/react/examples/blueprint-defect-mapper/', '997'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/generative-ui/',
                component: ComponentCreator('/docs/react/examples/generative-ui/', '40e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/image-annotation-studio/',
                component: ComponentCreator('/docs/react/examples/image-annotation-studio/', 'd5e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/object-explorer/',
                component: ComponentCreator('/docs/react/examples/object-explorer/', '1c1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/performance-showcase/',
                component: ComponentCreator('/docs/react/examples/performance-showcase/', 'f0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/examples/slideshow-presentation/',
                component: ComponentCreator('/docs/react/examples/slideshow-presentation/', '37b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/controls/',
                component: ComponentCreator('/docs/react/fundamentals/controls/', '3a7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/objects/',
                component: ComponentCreator('/docs/react/fundamentals/objects/', 'be9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/persistence/',
                component: ComponentCreator('/docs/react/fundamentals/persistence/', '538'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/tools/',
                component: ComponentCreator('/docs/react/fundamentals/tools/', 'd7e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/viewport/',
                component: ComponentCreator('/docs/react/fundamentals/viewport/', '9d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/fundamentals/workspaces/',
                component: ComponentCreator('/docs/react/fundamentals/workspaces/', '6ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/getting-started/basic-usage/',
                component: ComponentCreator('/docs/react/getting-started/basic-usage/', '905'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/getting-started/quick-start/',
                component: ComponentCreator('/docs/react/getting-started/quick-start/', '305'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/react/license/',
                component: ComponentCreator('/docs/react/license/', '3af'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/docs/vue/',
    component: ComponentCreator('/docs/vue/', 'e7e'),
    routes: [
      {
        path: '/docs/vue/',
        component: ComponentCreator('/docs/vue/', 'fde'),
        routes: [
          {
            path: '/docs/vue/',
            component: ComponentCreator('/docs/vue/', 'b05'),
            routes: [
              {
                path: '/docs/vue/advanced/agentic-cursors/',
                component: ComponentCreator('/docs/vue/advanced/agentic-cursors/', 'f69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/advanced/collaboration/',
                component: ComponentCreator('/docs/vue/advanced/collaboration/', 'b17'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/advanced/dynamic-objects/',
                component: ComponentCreator('/docs/vue/advanced/dynamic-objects/', 'ae2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/advanced/import-export/',
                component: ComponentCreator('/docs/vue/advanced/import-export/', '81a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/advanced/user-management/',
                component: ComponentCreator('/docs/vue/advanced/user-management/', '453'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/editor/',
                component: ComponentCreator('/docs/vue/api-reference/editor/', '4cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/engine/',
                component: ComponentCreator('/docs/vue/api-reference/engine/', 'b4f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/icons/',
                component: ComponentCreator('/docs/vue/api-reference/icons/', '3d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/localization-terms/',
                component: ComponentCreator('/docs/vue/api-reference/localization-terms/', '9a8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/objects/',
                component: ComponentCreator('/docs/vue/api-reference/objects/', '1b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/providers/',
                component: ComponentCreator('/docs/vue/api-reference/providers/', '5af'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/theming/',
                component: ComponentCreator('/docs/vue/api-reference/theming/', '5e5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/tools/',
                component: ComponentCreator('/docs/vue/api-reference/tools/', '330'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/api-reference/types/',
                component: ComponentCreator('/docs/vue/api-reference/types/', 'ae9'),
                exact: true
              },
              {
                path: '/docs/vue/customization/fonts/',
                component: ComponentCreator('/docs/vue/customization/fonts/', '4cf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/customization/icons/',
                component: ComponentCreator('/docs/vue/customization/icons/', '357'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/customization/locales/',
                component: ComponentCreator('/docs/vue/customization/locales/', '107'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/customization/themes/',
                component: ComponentCreator('/docs/vue/customization/themes/', 'b43'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/blueprint-defect-mapper/',
                component: ComponentCreator('/docs/vue/examples/blueprint-defect-mapper/', '050'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/generative-ui/',
                component: ComponentCreator('/docs/vue/examples/generative-ui/', '037'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/image-annotation-studio/',
                component: ComponentCreator('/docs/vue/examples/image-annotation-studio/', '273'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/object-explorer/',
                component: ComponentCreator('/docs/vue/examples/object-explorer/', 'c06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/performance-showcase/',
                component: ComponentCreator('/docs/vue/examples/performance-showcase/', 'b7d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/examples/slideshow-presentation/',
                component: ComponentCreator('/docs/vue/examples/slideshow-presentation/', 'a48'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/controls/',
                component: ComponentCreator('/docs/vue/fundamentals/controls/', '850'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/objects/',
                component: ComponentCreator('/docs/vue/fundamentals/objects/', '4df'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/persistence/',
                component: ComponentCreator('/docs/vue/fundamentals/persistence/', 'dcf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/tools/',
                component: ComponentCreator('/docs/vue/fundamentals/tools/', 'e2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/viewport/',
                component: ComponentCreator('/docs/vue/fundamentals/viewport/', '786'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/fundamentals/workspaces/',
                component: ComponentCreator('/docs/vue/fundamentals/workspaces/', '37d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/getting-started/basic-usage/',
                component: ComponentCreator('/docs/vue/getting-started/basic-usage/', '0c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/getting-started/quick-start/',
                component: ComponentCreator('/docs/vue/getting-started/quick-start/', '8a8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/vue/license/',
                component: ComponentCreator('/docs/vue/license/', '47b'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
